import { render, staticRenderFns } from "./InputFromKomship.vue?vue&type=template&id=666533c2&scoped=true&"
import script from "./InputFromKomship.vue?vue&type=script&lang=js&"
export * from "./InputFromKomship.vue?vue&type=script&lang=js&"
import style0 from "./InputFromKomship.vue?vue&type=style&index=0&id=666533c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666533c2",
  null
  
)

export default component.exports